<template>
  <component :is="layout">
    <router-view />
  </component>
  <LanguageSwitcher />
</template>

<script setup>
import { computed, onMounted } from 'vue'
import HomeLayout from '@/layouts/HomeLayout.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { useStore } from 'vuex'
import { scrollToTop } from '@/utils/scroll'

const store = useStore()

const getAvailableLanguageCodes = computed(() => store.getters['language/getAvailableLanguageCodes'])

const layout = computed(() => {
  return HomeLayout
})

// 语言
const isDomestic = (countryCode) => {
  // 境内国家代码
  const domesticCountries = ['CN', 'TW', 'HK']
  return domesticCountries.includes(countryCode)
}

const getCountryFromIP = () => {
  const appLanguage = localStorage.getItem('app-language')
  getAvailableLanguageCodes
  if (appLanguage && getAvailableLanguageCodes.value.includes(appLanguage)) return;

  fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
      const userIP = data.ip;
      fetch(`https://ipinfo.io/${userIP}?token=b479a94d2236bb`)
        .then(response => response.json())
        .then(locationData => {
          const country = locationData.country;
          if (!isDomestic(country)) {
            store.dispatch('language/switchLanguage', 'en')
          } else {
            store.dispatch('language/switchLanguage', 'zh-TW')
          }
        })
        .catch(error => console.error('Error fetching location:', error));
    })
    .catch(error => console.error('Error fetching IP address:', error));
}

onMounted(() => {
  getCountryFromIP()
  
  // 页面加载完成后确保置顶
  scrollToTop()
})
</script>

<style lang="scss">
@use '@/assets/styles/global.scss' as *;

#app {
  background: #ffffff;
}

.modal-open {
  pointer-events: none;
  user-select: none;
  opacity: 0.6;
}
</style>
